module.exports = __webpack_public_path__ + "img/2023big37.5f95724c.png";